import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

function BackNavigationPure({
  title,
  backText,
  showBackTextMobile,
  theme,
  defaultBackText,
  className,
  titleClassName,
  fitContent,
  handleBack,
  renderIcon
}) {
  return (
    <div className={`${styles.backBtnWrapper} ${fitContent && styles.fitContent} ${className} ${styles[theme]}`}>
      <button onClick={handleBack} className={styles.iconWrapper}>
        {renderIcon && renderIcon()}
        <p
          className={`${styles.back} ${titleClassName} ${showBackTextMobile && styles.backTextMobile}`}
          dangerouslySetInnerHTML={{ __html: backText ? backText : defaultBackText }}
        />
      </button>
      {title && <span className={styles.title}>{title}</span>}
    </div>
  )
}

BackNavigationPure.propTypes = {
  title: PropTypes.string,
  backText: PropTypes.string,
  defaultBackText: PropTypes.string,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  handleBack: PropTypes.func,
  renderIcon: PropTypes.func
}

export default BackNavigationPure
